<template>
  <div class="container bg_white">
    <mt-header fixed title="合同详情" class="head">
      <router-link to="/contract" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
      <router-link to="/contractModify" slot="right">
        <mt-button v-if="modifyShow" @click="modify(contractid)">修正</mt-button>
      </router-link>
    </mt-header>
    <div class="c_p_10">
      <div class="c_center c-title">屋顶防水技术服务合同</div>
      <div class="c_right">签订日期：<span class="c_underline"> {{startdate}} </span></div>
      <div class="c_right">签订地点： <span class="c_underline"> 北京市大兴区</span>&nbsp;&nbsp;&nbsp;</div>
      <div class="" v-if="contract.clientname">委托方：<span class="c_underline"> {{contract.clientname}} </span>（甲方）</div>
      <div class="" v-else>委托方：<span class="c_underline"> {{contract.name}} </span>（甲方）</div>
      <div class="">经办人：<span class="c_underline"></span></div>
      <div class="">电话：<span class="c_underline"> {{contract.phone}} </span></div>
      <div class="">身份证号：<span class="c_underline"> {{contract.idnumber}} </span></div>
      <div class="" v-if="contract.postaladdress">通讯地址：<span class="c_flex_1 c_underline"> {{contract.postaladdress}} </span></div>
      <div class="" v-else>通讯地址：<span class="c_flex_1 c_underline"> {{contract.address}} </span></div>
      <div class="">受托方：<span class="c_underline"> 北京顶之美建筑科技有限责任公司(系东方雨虹集团全资子公司) </span>（乙方）</div>
      <div class="">电话：<span class="c_underline"> 400-770-8966 </span></div>
      <div class="">通讯地址：<span class="c_underline"> 北京市北京经济技术开发区景园北街2号27幢1层8106室 </span></div>
      <div class="c_inent_10">
        经协商，甲、乙双方就
        <input type="checkbox" disabled :checked="part.indexOf('卫生间') != -1 ? true:false">卫生间
        <input type="checkbox" disabled :checked="part.indexOf('平屋面') != -1 ? true:false">平屋面
        <input type="checkbox" disabled :checked="part.indexOf('斜屋面') != -1 ? true:false">斜屋面
        <input type="checkbox" disabled :checked="part.indexOf('露台') != -1 ? true:false">露台
        <input type="checkbox" disabled :checked="part.indexOf('金属屋面') != -1 ? true:false">金属屋面
        <input type="checkbox" disabled :checked="part.indexOf('窗户') != -1 ? true:false">窗户
        <input type="checkbox" disabled :checked="part.indexOf('采光顶') != -1 ? true:false">采光顶
        等类型屋面防水技术服务达成如下协议：
      </div>
      <div class="c-title">第一条 服务内容</div>
      <div class="table">
        <table class="c_center">
          <thead>
          <tr>
            <th>序号</th>
            <th colspan="2">项目内容</th>
            <th>单价(元/㎡)</th>
            <th>面积(㎡)</th>
            <th>费用(元)</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for='(item,index) in contract.baseDetail'>
            <td v-if='index==0' :rowspan="contract.baseDetail.length">1</td>
            <td v-if='index==0' :rowspan="contract.baseDetail.length">防水专修基础包</td>
            <td> {{item.itemname}} </td>
            <td> {{item.price}} </td>
            <td> {{item.num}} </td>
            <td> {{item.amount}} </td>
          </tr>
          <tr v-for='(item,index) in contract.addDetail' :key='index'>
            <td v-if='index==0' :rowspan="contract.addDetail.length">2</td>
            <td v-if='index==0' :rowspan="contract.addDetail.length">防水维修辅助包</td>
            <td> {{item.itemname}} </td>
            <td> {{item.price}} </td>
            <td> {{item.num}} </td>
            <td> {{item.amount}} </td>
          </tr>
          <tr>
            <td rowspan="2">{{!contract.addDetail || !contract.baseDetail ? 2 : 3}}</td>
            <td rowspan='2'>优惠</td>
            <td colspan='2'>活动项目</td>
            <td colspan="2">金额</td>
          </tr>
          <tr>
            <td colspan='2'>&nbsp;</td>
            <td colspan='2'>&nbsp;</td>
          </tr>
          <tr>
            <td>{{!contract.addDetail || !contract.baseDetail ? 3 : 4}}</td>
            <td colspan="3">费用总计(元)</td>
            <td colspan="2"> {{contract.totalamount}} </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="c-title">第二条 服务地点</div>
      <div class="c_inent_10 c_underline">
         {{contract.address}}
      </div>
      <div class="c-title">第三条 服务时间</div>
      <div class="c_inent_10 c_underline">
        <span> {{startdate}} </span> 至
        <span> {{endDate}} </span>
      </div>
      <div class="c-title">第四条 结算方式</div>
      <div class="c_inent_10 c_underline">
        进场前支付不低于合同总金额的50%，整体验收完成后2日内结清尾款
      </div>
      <div class="c-title">第五条 双方责任</div>
      <div class="c_flex">
        <div class="">甲方：</div>
        <div class="c_flex_1">
          1.免费提供乙方所需水电等必要物资设备。<br>
          2.做好前期准备工作，协助乙方按时进场，并协调现场关系。<br>
          3.为乙方提供材料放置空间等方便。<br>
          4.服务过程中如有变更，应提前一天通知乙方，并负责随时检查、督促工作进度和质量。<br>
          5.按合同约定及时付款。<br>
        </div>
      </div>
      <div class="c_flex">
        <div class="">乙方：</div>
        <div class="c_flex_1">
          1.按相关服务方案、技术指标及有关规范组织技术服务，保证质量。<br>
          2.精心组织防水技术服务，保证服务进度。
        </div>
      </div>
      <div class="c-title">第六条 现场负责人</div>
      <div class="c_inent_10">甲方负责人： <span class="c_underline"> {{contract.name}} </span>
      &nbsp;&nbsp;&nbsp;联系方式： <span class="c_underline"> {{contract.phone}} </span>
      </div>
      <div class="c_inent_10">乙方负责人： <span class="c_underline">  {{contract.user_name}} </span>
      &nbsp;&nbsp;&nbsp;联系方式： <span class="c_underline"> {{contract.user_mobile}} </span></div>
      <div class="c_inent_10">双方现场负责人有权就本防水技术服务相关签证验收资料、洽商、通知等文件代表乙方签发签收。</div>

      <div class="c-title">第七条 服务项目验收</div>
      <div class="c_inent_10">
        项目服务过程中关键节点验收，需提前告知甲方验收时间，甲方不能到场查验的应拍摄照片传给甲方，合格后进行下一道工序。
      </div>
      <div class="c_inent_10">
        验收资料加盖甲乙双方印章或双方在合同中指定的负责人（或双方合同签约代表）签字后即具有法律效力。
      </div>
      <div class="c_inent_10">
        本服务项目验收合格后，乙方对所涉项目提供PICC承保的质保单，质保单在甲方完全支付全部款项后生效。
      </div>

      <div class="c-title">第八条  保修期</div>
      <div class="c_inent_10">
        本防水技术服务由乙方负责承保十年（自验收合格之日起计算）。保修期内，因乙方责任造成的防水服务质量问题,乙方负有免费提供后续服务的责任；不在乙方保修范围之列的，乙方同意有偿服务。
      </div>

      <div class="c-title">第九条  送达</div>
      <div class="c_inent_10">
        在合同执行期内，甲乙双方应将其联系电话、传真、邮箱及通讯地址、联系人等内容在本合同中列明。如有变更，应提前以书面形式向对方告知。一方根据对方提供的联系方式联系不上，视已经履行相应的通知义务。
      </div>

      <div class="c-title">第十条  不可抗力</div>
      <div class="c_inent_10">
        在合同内，如因地震、暴雨、冰雹、火灾、强风等自然因素或因政府命令、法律规定等客观因素不利于项目进展的，均视为不可抗力；由此不可抗力导致延误或无法履行本协议的，双方均不承担任何违约责任。
      </div>

      <div class="c-title">第十三条 其他事项及约定</div>
      <div class="c_inent_10">
        1、甲乙双方必须切实履行合同义务，如因一方违约，导致延误，全部责任由违约方承担。
      </div>
      <div class="c_inent_10">
        2、本合同所有款项应以票据、汇款方式支付。汇款方式支付应汇至乙方在合同中指定的户名、账号内；支票支付必须在票据中注明乙方为收款人；如现金付款，应先向乙方财务联系，在由乙方服务人员代收。
      </div>
      <div class="c_inent_10">
        3、乙方任何人员均无权代表乙方对本合同进行任何变更及承诺。如在本合同履行过程中需要对合同进行变更，包括但不限于变更、增加服务项目及做法、调价等，须经乙方盖章或签字确认后方可生效。
      </div>
      <div class="c_inent_10">
        4、发生争议，双方应协商解决，协商不成，双方约定施工项目所在地人民法院裁决。
      </div>
      <div class="c_inent_10">
        5、本合同自双方盖章或签字后生效，本合同一式叁份，甲方执壹份，乙方执贰份。
      </div>
      <br>
      <div class="c-title">（以下无正文）</div>
      <div class="c_flex c_flex_center">
        <div class="c_flex_1 c_left">甲方（签章）</div>
        <div class="c_flex_1 c_left">乙方（签章）</div>
      </div>
      <div class="c_flex c_flex_center">
        <div class="c_flex_1 c_left">经办人： <span>  </span></div>
        <div class="c_flex_1 c_left">联系人： <span> {{contract.user_name}} </span></div>
      </div>
      <div class="c_flex c_flex_center">
        <div class="c_flex_1 c_left">汇款开户银行： <span> ______ </span></div>
        <div class="c_flex_1 c_left">汇款开户银行： <span> 中国建设银行股份有限公司北京财满街支行 </span></div>
      </div>
      <div class="c_flex c_flex_center">
        <div class="c_flex_1 c_left"></div>
        <div class="c_flex_1 c_left">汇款户名： <span> 北京顶之美建筑科技有限责任公司 </span></div>
      </div>
      <div class="c_flex c_flex_center">
        <div class="c_flex_1 c_left">汇款帐号： <span> ______ </span></div>
        <div class="c_flex_1 c_left">汇款帐号： <span> 1105 0172 7900 0000 1105 </span></div>
      </div>
      <div class="c_right c_p_10">
        <img style="width:80px" src="../assets/images/alipay.png">
        <img style="width:80px" src="../assets/images/tmall.png">
      </div>

      <div class="c-title">附件：</div>
      <div class="c-title c_center">委托付款说明</div>
      <div class="c_inent_10 ">
        致： <span class="c_underline"> 北京顶之美建筑科技有限责任公司 </span>
      </div>
      <div class="c_inent_10 ">
        兹有我本司/本人 <span class="c_underline"> {{contract.name}} </span>于 <span class="c_underline"> _____ </span>年 <span class="c_underline"> _____ </span>月  <span class="c_underline"> _____ </span>日汇入 <span class="c_underline"> 北京顶之美建筑科技有限责任公司 </span>&nbsp;&nbsp;<span class="c_underline"> {{contract.totalamount}} 元 </span>（大写：人民币 <span class="c_underline"> _____ </span>元整），此笔款项是由我司/我自愿代 <span class="c_underline"> {{contract.customername}} </span>支付 <span class="c_underline"> {{contract.address}} </span>项目的  <span class="c_underline"> _____ </span>（例如：材料款/维修服务款），上述事宜由此引起的一切经济责任与他人无关，由本司/本人自行承担。
      </div>
      <div class="c_inent_10 ">
        特此说明
      </div>

      <div class="c_flex c_flex_center">
        <div class="c_flex_1 c_left">债务方（盖章/签字）：<span>  </span></div>
        <div class="c_flex_1 c_left">付款方（盖章/签字）：<span>  </span></div>
      </div>
      <div class="c_flex c_flex_center">
        <div class="c_flex_1 c_left">日期：<span>  </span></div>
        <div class="c_flex_1 c_left">日期：<span>  </span></div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "contractDetail",
        data:function () {
            return {
              modifyShow:false,
              contractid:'',
              contract:{},
              type:true,
              servicePlace:'',//服务地址
              startdate:'',//开始时间 年月日
              endDate:'',//结束时间 年月日
              part:''  //维修部位
            }
        },
        mounted:function () {
          let id = this.$route.params.id;
          if(id){
            this.contractid = id;
          }else{
            this.$router.push('/contract');
          }
          console.log(this.contractid);
          this.getUsertype();
          this.loadList();
        },
        methods:{
            getUsertype(){
              if(localStorage['userinfo']){
               var userinfo=JSON.parse(localStorage['userinfo']);
                console.log(userinfo)
                if(userinfo.usertype=='sysuser'){
                  this.modifyShow=true;
                }
              }

            },
            loadList:function () {
              let $that = this;
              this.$indicator.open();
              this.$ajax.get(this.$$api.mobile.getContractDetail,{
                //'sortField':'ts',
                //'sortDirection':'desc',
                //search_contractid:this.contractid
                'contractid':$that.contractid,
              },response=>{
                console.log(response)
                if (response.status >= 200 && response.status < 300) {
                  if(response.data.success=='success'){
                    var msg=response.data.detailMsg.data;
                    $that.contract = msg;
                    console.log(msg)
                    //时间
                    $that.startdate=msg.startdate.split('-')[0]+'年'+msg.startdate.split('-')[1]+'月'+msg.startdate.split('-')[2]+'日';
                    var planneddate=15;
                    if(msg.planneddate){
                      planneddate=msg.planneddate;
                    }
                    var endDate=new Date(new Date(msg.startdate).getTime() + parseFloat(planneddate)*24*60*60*1000);
                    var year=endDate.getFullYear();
                    var month=endDate.getMonth()+1;
                    var date=endDate.getDate();
                    $that.endDate=year+'年'+month+'月'+date+'日';
                    //维修部位
                    $that.part=msg.part;
                  }
                } else {
                  console.log(response,0);
                }
                $that.$indicator.close();
              });
            },
            modify(id){
                var id=id;
                this.$router.push({name: "contractModify", params: {'id': id}});
            }
        }
    }
</script>

<style scoped>
  .c_inent_10{
    text-indent: 3.226vw;
  }
  .table table{
    border:0;
    margin:0;
    border-collapse:collapse;
    border-spacing:0;
    width: 100%;
  }
  .table th,
  .table td{
    border: 1px solid #ccc;
    width: 16.5%;
  }
  .c-title{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/contractDetail.vue